import React from "react";

import { ErrorMessage } from "../../common/ErrorMessage";
import { WarningMessage } from "../../common/WarningMessage";

type Props = {
  isHidden?: boolean;
  message?: string;
  messageHtml?: string;
  title?: string;
  action?: () => void;
  actionText?: string;
  type?: "error" | "warning";
  screen?: string;
};

export const ErrorCard: React.FC<Props> = props => {
  if (props.isHidden) {
    return <></>;
  }

  return props.type === "warning" ? (
    <WarningMessage
      title={props.title}
      message={props.message ?? ""}
      action={props.action}
      actionText={props.actionText}
    />
  ) : (
    <ErrorMessage
      screen={props.screen ?? "importDetails"}
      title={props.title}
      message={props.message}
      messageHtml={props.messageHtml}
      action={props.action}
      actionText={props.actionText}
    />
  );
};
